import React, { useMemo, useState } from 'react'
import { useMutation } from 'react-query'
import { submitProjectFeedback } from '../../api/feedback'
import StarRatingField from './star-rating-field'

const defaultValues = {
  q1: '',
  q2: '',
  q3: '',
  q4: '',
}

const ProjectFeedbackForm = ({ token, customerFirstName, projectTitle, onSuccess = () => {} }) => {
  const [values, setValues] = useState(defaultValues)
  const [error, setError] = useState(null)

  const mutation = useMutation((payload) => submitProjectFeedback(payload), {
    onError: (err) => {
      setError(err.message || 'We could not submit your feedback. Please try again.')
    },
    onSuccess: () => {
      setError(null)
      onSuccess()
    },
  })

  const greetingName = useMemo(() => customerFirstName || 'there', [customerFirstName])

  const handleRatingChange = (field, value) => {
    setValues((prev) => ({ ...prev, [field]: value }))
  }

  const handleTextChange = (event) => {
    const { name, value } = event.target
    setValues((prev) => ({ ...prev, [name]: value }))
  }

  const handleSubmit = (event) => {
    event.preventDefault()
    setError(null)

    mutation.mutate({
      token,
      ...values,
    })
  }

  return (
    <form className="c-feedback-form" onSubmit={handleSubmit}>
      <div className="c-feedback-modal__intro">
        <h2 className="c-content-media__title c-feedback-intro__title">Hi{greetingName && ` ${greetingName}`},</h2>
        <div className="c-content-media__content c-feedback-intro__content">
          Thank you so much for taking a moment to share your feedback on our recent project
          {projectTitle ? <>, {projectTitle}</> : null}.
        </div>
      </div>

      <StarRatingField
        name="q1"
        label="How do you rate our performance?"
        value={values.q1}
        onChange={(val) => handleRatingChange('q1', val)}
      />

      <div className="c-feedback-field">
        <label className="c-form__label" htmlFor="project-q2">
          What influenced your rating?
        </label>
        <textarea
          id="project-q2"
          name="q2"
          rows="4"
          className="c-form__textarea"
          value={values.q2}
          onChange={handleTextChange}
        />
      </div>

      <div className="c-feedback-field">
        <label className="c-form__label" htmlFor="project-q3">
          What was the MOST USEFUL aspect of the work for you?
        </label>
        <input
          id="project-q3"
          name="q3"
          type="text"
          className="c-form__textbox"
          value={values.q3}
          onChange={handleTextChange}
        />
      </div>

      <div className="c-feedback-field">
        <label className="c-form__label" htmlFor="project-q4">
          If we could do ONE THING to improve the output, what would it be?
        </label>
        <input
          id="project-q4"
          name="q4"
          type="text"
          className="c-form__textbox"
          value={values.q4}
          onChange={handleTextChange}
        />
      </div>

      <div className="c-feedback-form__actions">
        {error ? (
          <div className="f-messages">
            <div className="f-messages__alert f-messages__alert--error">
              <p>{error}</p>
            </div>
          </div>
        ) : null}

        <button type="submit" className="c-btn c-btn--large c-btn--primary" disabled={mutation.isLoading}>
          {mutation.isLoading ? 'Submitting...' : 'Send feedback'}
        </button>
      </div>
    </form>
  )
}

export default ProjectFeedbackForm
